// Single write/delete path for MTN-owned cookies (MTN-321): every write
// carries Secure, SameSite=Lax, and Path=/, host-only by default. Pass
// `parent: true` only for a cookie with a named cross-subdomain consumer
// (MTN-1434 browser-storage disposition).

const PARENT_ATTRIBUTE = "; domain=.moneytalksnews.com";

// An empty value still matches ([^;]*), so get() distinguishes "cookie set
// to empty" ("") from "cookie absent" (undefined) — setIfChanged relies on
// that to skip rewriting an empty mirror on every page load.
export const get = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[2]) : undefined;
};

export const set = (name, value, { days, parent = false } = {}) => {
  // Drop the other-scope copy a past writer may have left: at equal path,
  // the older cookie sorts first, so a stale value from the old scope would
  // shadow this write.
  document.cookie = `${name}=${parent ? "" : PARENT_ATTRIBUTE}; max-age=0; path=/; Secure; SameSite=Lax`;
  const maxAge =
    days === undefined ? "" : `; max-age=${Math.round(days * 86_400)}`;
  document.cookie = `${name}=${encodeURIComponent(value)}${parent ? PARENT_ATTRIBUTE : ""}${maxAge}; path=/; Secure; SameSite=Lax`;
};

// Deletes host-only and parent-domain variants. Every MTN writer uses
// Path=/, so no other paths need covering.
export const remove = (name) => {
  document.cookie = `${name}=; max-age=0; path=/; Secure; SameSite=Lax`;
  document.cookie = `${name}=${PARENT_ATTRIBUTE}; max-age=0; path=/; Secure; SameSite=Lax`;
};

// For mirror cookies rewritten on every page: a page load alone must not
// renew retention (MTN-321), so this touches the jar only when the value
// changed — or after expiry, when the stored value reads as missing and the
// next page load restores it. get() cannot tell a host-only cookie from a
// parent-domain one with the same name and value; the set() other-scope
// pre-delete only runs when the value differs.
export const setIfChanged = (name, value, options) => {
  if (get(name) === String(value)) {
    return;
  }
  set(name, value, options);
};
